import React, { PureComponent } from 'react'
import { translate } from 'react-polyglot'

import { ButtonGroup, Button, Text, FlexContainer } from 'components'
import IcecreamSvg from 'assets/img/svg/icecream.js'

import './error.scss'

class Error extends PureComponent {
	render() {
		const { t } = this.props
		const componentClass = 'c-error'

		return (
			<div className={componentClass}>
				<FlexContainer
					className={`${componentClass}__header`}
					withPadding
				>
					<img src="/assets/img/logo-beta.svg" alt="Skara" />
				</FlexContainer>
				<div className={`${componentClass}__inner`}>
					<div className="grid" data-grid="middle xx-wide">
						<div className="grid__item" data-grid--medium="7/12">
							<Text color="scheme" size="huge" weight="light">
								{t('frontend_error_big_text')}
							</Text>
							<h2>{t('frontend_error_title')}</h2>
							<Text color="dark">{t('frontend_error_text')}</Text>
							<ButtonGroup>
								<Button
									text={t('frontend_error_button')}
									layout="primary"
									onClick={() => {
										window.location.reload()
									}}
								/>
							</ButtonGroup>
						</div>
						<div className="grid__item" data-grid--medium="5/12">
							<IcecreamSvg
								style={{
									height: 'auto',
									width: '100%',
								}}
							/>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default translate()(Error)
